import router from '@/router'
import * as Sentry from '@sentry/vue'
import { appMode } from '../config/mode'

let vueApp = null
let isInitialized = false

/**
 * Initializes Sentry error reporting on the stored Vue instance.
 *
 * Sentry stays disabled until this is called, and it is only called once the
 * backend `/config` endpoint reports `sentry_enabled: true`. This keeps Sentry
 * off by default (e.g. on Cycloid on-prem installs) unless the backend opts in.
 *
 * @returns {void}
 */
export function enableSentry () {
  if (appMode.isDev || isInitialized || !vueApp) return

  Sentry.init({
    app: vueApp,
    dsn: import.meta.env.VUE_APP_SENTRY_URL,
    environment: import.meta.env.MODE,
    release: __APP_VERSION__,
    autoSessionTracking: false,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.05,
  })

  isInitialized = true
}

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    vueApp = app
  },
}
